import React, { useState } from 'react';
import { db } from "../firebaseConfig";
import { collection, addDoc } from 'firebase/firestore';

const BulkIssueUploader = () => {
  const [issues, setIssues] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [uploadStatus, setUploadStatus] = useState('');

  const handleFileUpload = async (file) => {
    setUploading(true);
    setUploadStatus('');

    try {
      const text = await file.text();
      const parsed = JSON.parse(text);

      if (!Array.isArray(parsed)) {
        throw new Error('JSON must be an array of issue objects.');
      }

      const validIssues = parsed.map((issue) => ({
        title: issue.title || '',
        description: issue.description || '',
        symptoms: issue.symptoms || '',
        resolution: issue.resolution || '',
        tags: Array.isArray(issue.tags) ? issue.tags : [],
      }));

      setIssues(validIssues);

      for (const issue of validIssues) {
        await addDoc(collection(db, 'common_issues'), issue);
      }

      setUploadStatus(`✅ Uploaded ${validIssues.length} issues to Firebase.`);
    } catch (err) {
      console.error('Upload failed:', err);
      setUploadStatus('❌ Failed to upload issues: ' + err.message);
    }

    setUploading(false);
  };

  const handleInputChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type === 'application/json') {
      handleFileUpload(file);
    } else {
      alert('Please upload a valid JSON file.');
    }
  };

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-2">Bulk Issue Uploader (JSON)</h2>
      <input type="file" accept=".json" onChange={handleInputChange} disabled={uploading} />
      {uploading && <p className="text-blue-500 mt-2">⏳ Uploading to Firestore...</p>}
      {uploadStatus && <p className="mt-2">{uploadStatus}</p>}

      <div className="mt-4">
        {issues.map((issue, index) => (
          <div key={index} className="p-2 border rounded mb-2">
            <strong>{issue.title}</strong>
            <p>{issue.description}</p>
            <p className="text-sm text-gray-500">Symptoms: {issue.symptoms}</p>
            <p className="text-sm text-green-600">Resolution: {issue.resolution}</p>
            <p className="text-xs text-blue-500 mt-1">Tags: {issue.tags.join(', ')}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BulkIssueUploader;
